import { FC } from "react";
import FlightDetails from "../components/FlightDetails";
import PassengerData from "../components/PassengerData";
import MobilePaymentDrawer from "../components/MobilePaymentDrawer";
import { TravelTransactionDetailsLayoutProps } from "./types";
import BookingSummary from "../components/BookingSummary";
import { flightOrderDataMap, getBookingSummaryCardData } from "../constants";

const TravelTransactionDetailsMob: FC<TravelTransactionDetailsLayoutProps> = ({ data }) => {
  return (
    <div className="flex w-full flex-col gap-2 pb-5">
      <div className="flex flex-col gap-4">
        <BookingSummary cardData={getBookingSummaryCardData(data)} dataMap={flightOrderDataMap} />
        <FlightDetails segments={(data?.segments ?? []) as any} />
        <PassengerData passengers={data?.passengers ?? []} />
      </div>
      <MobilePaymentDrawer data={data} />
    </div>
  );
};

export default TravelTransactionDetailsMob;
